'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ExposureLogger = require('../ExposureLogger/ExposureLogger');

var _ExposureLogger2 = _interopRequireDefault(_ExposureLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Configuration for initializing EgTnlBucket
 */
var BucketConfig =
/**
 * Creates a BucketConfig
 *
 * @param {Object.<number, EvaluationData>} tests - a dictionary of experiment ids to evaluation data objects
 * @param {ExposureLogger|Array.<ExposureLogger>} exposureLoggers - array of loggers to use for logging exposures
 */
function BucketConfig(evaluatedExperiments, exposureLoggers) {
    _classCallCheck(this, BucketConfig);

    this.evaluatedExperiments = evaluatedExperiments;
    this.exposureLoggers = exposureLoggers instanceof _ExposureLogger2.default ? [exposureLoggers] : exposureLoggers;
};

exports.default = BucketConfig;
//# sourceMappingURL=BucketConfig.js.map